/* istanbul ignore file */
import get from 'lodash/get';

export const basicInfoToHubsMapper = (collegeName, data, collegeService) => {
  const esLikeDeadlines = get(data, 'admissions.deadlines', []).map((deadline) => ({
    deadline: {
      field_he_deadlinetype: deadline.typeName,
      field_he_day_of_the_deadline: parseInt(deadline.day, 10),
      field_he_month_of_the_deadline: parseInt(deadline.month, 10),
      field_he_typeotherdescription: deadline.description,
    },
  }));
  const stateValue = get(data, `overview.admissionsOffice.state.options[${get(data, 'overview.admissionsOffice.state.value', null)}]`, null);
  const stateReps = stateValue ? stateValue.split(' - ') : [null, null];
  const trueFalse = (value, nullIfFalse = false) => {
    const trues = [1, '1', true, 'true', 'TRUE', 'yes', 'Yes', 'YES'];
    const falses = [0, '0', false, 'false', 'FALSE', 'no', 'No', 'NO'];
    if (trues.includes(value)) {
      return true;
    } else if (!nullIfFalse && falses.includes(value)) {
      return false;
    }
    return null;
  };
  const numberNull = (value) => (value === null || Number.isNaN(+value) ? null : +value);
  const valueNull = (value) => (value || null);
  const stateAbbrev = get(collegeService, 'esData.fullProfile.address.field_state_ref.field_state_short_name');

  const esLikeData = {
    address: {
      field_url: get(data, 'overview.website.value', null),
      field_postalcode: get(data, 'overview.admissionsOffice.zip.value', null),
      field_state_ref: {
        field_long_name: stateReps[0],
        field_state_short_name: stateReps[1] || stateAbbrev,
      },
    },
    sports: get(data, 'studentLife.athletics', []).map((sport) => {
      const sportObject = {
        he_school_sport_us: {
          field_he_sport_name: collegeService.cmsDataMapping.sportNames[Number(sport.type)],
          field_he_assocwomen_id: valueNull(collegeService.cmsDataMapping.associationsWomen[sport.women.association]),
          field_he_assocmen_id: valueNull(collegeService.cmsDataMapping.associationsMen[sport.men.association]),
          field_he_assoccoed_id: valueNull(collegeService.cmsDataMapping.associationsCOED[sport.coed.association]),
          field_he_divwomen_id: valueNull(collegeService.cmsDataMapping.divisionsWomen[sport.women.division]),
          field_he_divmen_id: valueNull(collegeService.cmsDataMapping.divisionsMen[sport.men.division]),
          field_he_divcoed_id: valueNull(collegeService.cmsDataMapping.divisionsCOED[sport.coed.division]),
          field_he_confwomen_id: valueNull(collegeService.cmsDataMapping.conferencesWomen[sport.women.conference]),
          field_he_confmen_id: valueNull(collegeService.cmsDataMapping.conferencesMen[sport.men.conference]),
          field_he_confcoed_id: valueNull(collegeService.cmsDataMapping.conferencesCOED[sport.coed.conference]),
          field_he_clubwomen: trueFalse(get(sport, 'women.others.club')),
          field_he_clubmen: trueFalse(get(sport, 'men.others.club')),
          field_he_clubcoed: trueFalse(get(sport, 'coed.others.club')),
          field_he_intramuralwomen: trueFalse(get(sport, 'women.others.intramural')),
          field_he_intramuralmen: trueFalse(get(sport, 'men.others.intramural')),
          field_he_intramuralcoed: trueFalse(get(sport, 'coed.others.intramural')),
        },
      };
      return sportObject;
    }),
    housing: {
      field_he_housing_ref: {
        field_he_sophomoresmustliveoncam: trueFalse(get(data, 'studentLife.housingData.sophomoresMustLiveOnCampus.value', null)),
        field_he_freshmenmustliveoncampu: trueFalse(get(data, 'studentLife.housingData.freshmanMustLiveOnCampus.value', null)),
        field_he_camphouscap: numberNull(get(data, 'studentLife.housingData.campusHousingCapacity.value', null)),
        field_he_seniorsmustliveoncampus: trueFalse(get(data, 'studentLife.housingData.seniorsMustLiveOnCampus.value', null)),
        field_he_juniorsmustliveoncampus: trueFalse(get(data, 'studentLife.housingData.juniorsMustLiveOnCampus.value', null)),
      },
    },
    studentbody: {
      field_he_studentbodyid_ref: {
        calc_he_undergraduatesize:
          numberNull(get(data, 'overview.undergraduateEnrollment.women.value', 0)) +
          numberNull(get(data, 'overview.undergraduateEnrollment.men.value', 0)),
        field_he_numgradfemales: numberNull(get(data, 'studentLife.schoolSize.graduateWomen.value', null)),
        field_he_numugfemales: numberNull(get(data, 'studentLife.schoolSize.undergraduateWomen.value', null)),
        field_he_numgradmales: numberNull(get(data, 'studentLife.schoolSize.graduateMen.value', null)),
        field_he_numugmales: numberNull(get(data, 'studentLife.schoolSize.undergraduateMen.value', null)),
        field_he_pctafricanam: numberNull(get(data, 'studentLife.ethnicity.africanAmerican.value', null)),
        field_he_pctasian: numberNull(get(data, 'studentLife.ethnicity.asian.value', null)),
        field_he_pctnativeam: numberNull(get(data, 'studentLife.ethnicity.nativeAmerican.value', null)),
        field_he_pctcaucasian: numberNull(get(data, 'studentLife.ethnicity.caucasian.value', null)),
        field_he_pcthispanic: numberNull(get(data, 'studentLife.ethnicity.africanHispanic.value', null)),
        field_he_pctinternational: numberNull(get(data, 'studentLife.ethnicity.international.value', null)),
        field_he_pctliveoncamp: numberNull(get(data, 'studentLife.housingData.liveOnCampus.value', null)),
        field_he_pctnativepacificisland: numberNull(get(data, 'studentLife.ethnicity.nativePacificIslander.value', null)),
        field_he_pctnonresidentalien: numberNull(get(data, 'studentLife.ethnicity.nonResidentAlien.value', null)),
        field_he_pctoutofstate: numberNull(get(data, 'studentLife.housingData.liveOutOfState.value', null)),
        field_he_pctraceunknown: numberNull(get(data, 'studentLife.ethnicity.nativeUnknown.value', null)),
        field_he_pctstudentsgt24yrsold: numberNull(get(data, 'studentLife.ageData.value', null)),
        field_he_pcttwoormoreraces: numberNull(get(data, 'studentLife.ethnicity.twoOrMoreRaces.value', null)),
        field_he_popularareaofstudy1: get(data, 'studies.topAreasOfStudy.1.value', null),
        field_he_popularareaofstudy2: get(data, 'studies.topAreasOfStudy.2.value', null),
        field_he_popularareaofstudy3: get(data, 'studies.topAreasOfStudy.3.value', null),
        field_he_popularareaofstudy4: get(data, 'studies.topAreasOfStudy.4.value', null),
        field_he_popularareaofstudy5: get(data, 'studies.topAreasOfStudy.5.value', null),
        field_he_studentfacultyratio: numberNull(get(data, 'overview.studentFacultyRatio.value', null)),
      },
    },
    undergraduate_admissions: {
      field_he_undergradadmission_ref: {
        undergraduate_admissions_us: {
          field_he_waitinglistused: trueFalse(get(data, `admissions.importantPolicies.waitingList.options[${get(data, 'admissions.importantPolicies.waitingList.value', null)}]`, null)),
          field_he_transferapplicationfee: numberNull(get(data, 'admissions.fees.transferApplicationFee.value', null)),
          field_he_transferappdeposit: numberNull(get(data, 'admissions.fees.transferDepositFee.value', null)),
          field_he_testoptional: trueFalse(get(data, 'admissions.field_he_testoptional.value', null)),
          field_he_retentionratefulltime: numberNull(get(data, 'studies.studentRetention.value', null)),
          field_he_registrationpolicy_id: get(data, `admissions.importantPolicies.registrationPolicy.options[${get(data, 'admissions.importantPolicies.registrationPolicy.value', null)}]`, null),
          field_he_intlbaccalaureateplcmid: get(data, `admissions.he_undergraduate_admissions_us.field_he_intlbaccalaureateplcmid.options[${get(data, 'admissions.he_undergraduate_admissions_us.field_he_intlbaccalaureateplcmid.value', null)}]`, null),
          field_he_clepsubjectplacement_id: get(data, `admissions.he_undergraduate_admissions_us.field_he_clepsubjectplacement_id.options[${get(data, 'admissions.he_undergraduate_admissions_us.field_he_clepsubjectplacement_id.value', null)}]`, null),
          field_he_ceebadvancedplacementid: get(data, `admissions.he_undergraduate_admissions_us.field_he_ceebadvancedplacementid.options[${get(data, 'admissions.he_undergraduate_admissions_us.field_he_ceebadvancedplacementid.value', null)}]`, null),
          field_he_gpa_25th_percentile: numberNull(get(data, 'overview.gpa.25.value', null)),
          field_he_gpa_75th_percentile: numberNull(get(data, 'overview.gpa.75.value', null)),
          field_he_gpaaverage: numberNull(get(data, 'overview.gpa.50.value', null)),
          field_he_earlydecision: trueFalse(get(data, `admissions.importantPolicies.earlyDecision.options[${get(data, 'admissions.importantPolicies.earlyDecision.value', null)}]`, null)),
          field_he_clepcredit: trueFalse(get(data, 'admissions.he_undergraduate_admissions_us.field_he_clepcredit.value', null)),
          field_he_apcredit: trueFalse(get(data, 'admissions.he_undergraduate_admissions_us.field_he_apcredit.value', null)),
          field_he_admissionspolicy_id: [get(data, `admissions.importantPolicies.admissionsPolicy.options[${get(data, 'admissions.importantPolicies.admissionsPolicy.value', null)}]`, null)],
          field_he_notificationpolicy_id: [get(data, `admissions.importantPolicies.notificationPolicy.options[${get(data, 'admissions.importantPolicies.notificationPolicy.value', null)}]`, null)],
        },
        qualification_data: get(data, 'admissions.qualification_data', null),
        test: {
          field_he_test_us: get(data, 'overview.field_he_test_us', null),
        },
        admission_general: {
          field_he_deposit: get(data, 'admissions.fees.deposit.value', null),
          field_he_applications_accepted: get(data, 'admissions.acceptanceRate.applicationsAccepted.value', null),
          field_he_applications_received: get(data, 'admissions.acceptanceRate.applicationsReceived.value', null),
          field_he_applicationfee: get(data, 'admissions.fees.applicationFee.value', null),
        },
        app_address_ref: {
          field_addressline1: get(data, 'overview.applicationMailingAddress.street1.value', null),
          field_addressline2: get(data, 'overview.applicationMailingAddress.street2.value', null),
          field_url: get(data, 'overview.applicationMailingAddress.url.value', null),
          field_emailaddress: get(data, 'overview.applicationMailingAddress.email.value', null),
          field_faxnumber: get(data, 'overview.applicationMailingAddress.fax.value', null),
          field_postalcode: get(data, 'overview.applicationMailingAddress.zip.value', null),
          field_city: get(data, 'overview.applicationMailingAddress.city.value', null),
          field_phonenumber: get(data, 'overview.applicationMailingAddress.phoneNumber.value', null),
          field_tollfreenumber: get(data, 'overview.applicationMailingAddress.tollFreeNumber.value', null),
          field_state_ref: {
            name: get(data, `overview.applicationMailingAddress.state.options[${get(data, 'overview.applicationMailingAddress.state.value', null)}]`, null),
            field_state_short_name: get(data, `overview.applicationMailingAddress.state.options[${get(data, 'overview.applicationMailingAddress.state.value', null)}]`, '').split(' - ')[1],
            field_long_name: get(data, `overview.applicationMailingAddress.state.options[${get(data, 'overview.applicationMailingAddress.state.value', null)}]`, '').split(' - ')[0],
          },
          field_country_ref: {
            field_country_fullname: get(data, `overview.applicationMailingAddress.country.options[${get(data, 'overview.applicationMailingAddress.country.value', null)}]`, ''),
            name: get(data, `overview.applicationMailingAddress.country.options[${get(data, 'overview.applicationMailingAddress.country.value', null)}]`, ''),
          },
        },
        high_school_prerequisites: {
          field_he_highschoolprerequisites: get(data, 'admissions.recommendedCourses', null),
        },
        graduate_rate: {
          field_he_gradratebachelors4yrs: numberNull(get(data, 'studies.field_he_gradratebachelors4yrs.value', null)),
          field_he_gradratebachelors6yrs: numberNull(get(data, 'studies.field_he_gradratebachelors6yrs.value', null)),
        },
        admissions_contact: {
          field_he_admissions_contact_ref: {
            address: {
              field_addressline1: get(data, 'overview.admissionsOffice.street1.value', null),
              field_addressline2: get(data, 'overview.admissionsOffice.street2.value', null),
              field_url: get(data, 'overview.admissionsOffice.url.value', null),
              field_emailaddress: get(data, 'overview.admissionsOffice.email.value', null),
              field_faxnumber: get(data, 'overview.admissionsOffice.fax.value', null),
              field_postalcode: get(data, 'overview.admissionsOffice.zip.value', null),
              field_city: get(data, 'overview.admissionsOffice.city.value', null),
              field_phonenumber: get(data, 'overview.admissionsOffice.phoneNumber.value', null),
              field_tollfreenumber: get(data, 'overview.admissionsOffice.tollFreeNumber.value', null),
              field_state_ref: {
                name: get(data, `overview.admissionsOffice.state.options[${get(data, 'overview.admissionsOffice.state.value', null)}]`, null),
                field_state_short_name: get(data, `overview.admissionsOffice.state.options[${get(data, 'overview.admissionsOffice.state.value', null)}]`, '').split(' - ')[1],
                field_long_name: get(data, `overview.admissionsOffice.state.options[${get(data, 'overview.admissionsOffice.state.value', null)}]`, '').split(' - ')[0],
              },
              field_country_ref: {
                field_country_fullname: get(data, `overview.admissionsOffice.country.options[${get(data, 'overview.admissionsOffice.country.value', null)}]`, ''),
                name: get(data, `overview.admissionsOffice.country.options[${get(data, 'overview.admissionsOffice.country.value', null)}]`, ''),
              },
            },
            contact: {
              field_nameprefix: get(data, 'overview.admissionsOffice.namePrefix.value', null),
              field_firstname: get(data, 'overview.admissionsOffice.firstName.value', null),
              field_middlename: get(data, 'overview.admissionsOffice.middleName.value', null),
              field_lastname: get(data, 'overview.admissionsOffice.lastName.value', null),
              field_jobtitle: get(data, 'overview.admissionsOffice.jobTitle.value', null),
              field_jobdescription: get(data, 'overview.admissionsOffice.jobDescription.value', null),
            },
          },
        },
        field_address_id: 1,
        field_he_coalition_app_member: trueFalse(get(data, 'admissions.field_he_coalition_app_member.value', null)),
        field_he_common_app_member: trueFalse(get(data, 'admissions.field_he_common_app_member.value', null)),
        field_he_ib_credits: get(data, `admissions.he_undergraduate_admissions_us.field_he_ib_credits.options[${get(data, 'admissions.he_undergraduate_admissions_us.field_he_ib_credits.value', null)}]`, null),
        field_he_job_plcmnt_rt_1_yr_gr: numberNull(get(data, 'overview.field_he_job_plcmnt_rt_1_yr_gr.value', null)),
        field_he_job_plcmnt_rt_less_1_yr: numberNull(get(data, 'overview.field_he_job_plcmnt_rt_less_1_yr.value', null)),
        field_he_job_plcmnt_rt_less_6_mo: numberNull(get(data, 'overview.field_he_job_plcmnt_rt_less_6_mo.value', null)),
        admission_factor_data: {
          field_he_admission_factor_data: get(data, 'admissions.applicationFactors', null),
        },
      },
    },
    international_admissions: {
      field_he_intadmissions_ref: {
        admission_general_us: {
          field_he_applicationfee: numberNull(get(data, 'admissions.fees.internationalApplicationFee.value', null)),
          field_he_deposit: numberNull(get(data, 'admissions.fees.internationalDepositFee.value', null)),
        },
      },
    },
    field_he_id: {},
    deadlines: esLikeDeadlines,
    undergraduate_financial_aid: {
      field_he_undergradfinaidid_ref: {
        field_he_meets_full_fin_needs: trueFalse(get(data, `costs.costItems.field_he_meets_full_fin_needs.options[${get(data, 'costs.costItems.field_he_meets_full_fin_needs.value', null)}]`, null)),
        financial_aid_general: {
          field_he_financial_profile: [
            {
              field_he_value: get(data, 'costs.receivingAid.grant.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.receivingAid.grant.label', null),
            },
            {
              field_he_value: get(data, 'costs.receivingAid.pellGrant.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.receivingAid.pellGrant.label', null),
            },
            {
              field_he_value: get(data, 'costs.receivingAid.studentLoan.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.receivingAid.studentLoan.label', null),
            },
            {
              field_he_value: get(data, 'costs.averageAmountOfAid.grant.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageAmountOfAid.grant.label', null),
            },
            {
              field_he_value: get(data, 'costs.averageAmountOfAid.pellGrant.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageAmountOfAid.pellGrant.label', null),
            },
            {
              field_he_value: get(data, 'costs.averageAmountOfAid.studentLoan.value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageAmountOfAid.studentLoan.label', null),
            },
            {
              field_he_value: get(data, 'costs.averageNetPrices["0-30"].value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageNetPrices["0-30"].label', null),
            },
            {
              field_he_value: get(data, 'costs.averageNetPrices["30-48"].value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageNetPrices["30-48"].label', null),
            },
            {
              field_he_value: get(data, 'costs.averageNetPrices["48-75"].value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageNetPrices["48-75"].label', null),
            },
            {
              field_he_value: get(data, 'costs.averageNetPrices["75-110"].value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageNetPrices["75-110"].label', null),
            },
            {
              field_he_value: get(data, 'costs.averageNetPrices["110+"].value', null),
              field_he_financialaidprofiletype: get(data, 'costs.averageNetPrices["110+"].label', null),
            },
          ],
        },
        contact: {
          field_he_finaidcontact_ref: {
            address: {
              field_addressline1: get(data, 'overview.financialAid.street1.value', null),
              field_addressline2: get(data, 'overview.financialAid.street2.value', null),
              field_url: get(data, 'overview.financialAid.url.value', null),
              field_emailaddress: get(data, 'overview.financialAid.email.value', null),
              field_faxnumber: get(data, 'overview.financialAid.fax.value', null),
              field_postalcode: get(data, 'overview.financialAid.zip.value', null),
              field_city: get(data, 'overview.financialAid.city.value', null),
              field_phonenumber: get(data, 'overview.financialAid.phoneNumber.value', null),
              field_tollfreenumber: get(data, 'overview.financialAid.tollFreeNumber.value', null),
              field_state_ref: {
                name: get(data, `overview.financialAid.state.options[${get(data, 'overview.financialAid.state.value', null)}]`, null),
                field_state_short_name: get(data, `overview.financialAid.state.options[${get(data, 'overview.financialAid.state.value', null)}]`, '').split(' - ')[1],
                field_long_name: get(data, `overview.financialAid.state.options[${get(data, 'overview.financialAid.state.value', null)}]`, '').split(' - ')[0],
              },
              field_country_ref: {
                field_country_fullname: get(data, `overview.financialAid.country.options[${get(data, 'overview.financialAid.country.value', null)}]`, ''),
                name: get(data, `overview.financialAid.country.options[${get(data, 'overview.financialAid.country.value', null)}]`, ''),
              },
            },
            contact: {
              field_nameprefix: get(data, 'overview.admissionsOffice.namePrefix.value', null),
              field_firstname: get(data, 'overview.admissionsOffice.firstName.value', null),
              field_middlename: get(data, 'overview.admissionsOffice.middleName.value', null),
              field_lastname: get(data, 'overview.admissionsOffice.lastName.value', null),
              field_jobtitle: get(data, 'overview.admissionsOffice.jobTitle.value', null),
              field_jobdescription: get(data, 'overview.admissionsOffice.jobDescription.value', null),
            },
          },
        },
        undergraduate_financial_aid: {
          field_he_books: numberNull(get(data, 'costs.costItems.field_he_books.value', null)),
          field_he_booksplus1yr: numberNull(get(data, 'costs.costItems.field_he_booksplus1yr.value', null)),
          field_he_instateflatfee: numberNull(get(data, 'costs.costItems.field_he_instateflatfee.value', null)),
          field_he_instateflatfeeplus1yr: numberNull(get(data, 'costs.costItems.field_he_instateflatfeeplus1yr.value', null)),
          field_he_instatetuition: numberNull(get(data, 'costs.costItems.field_he_instatetuition.value', null)),
          field_he_instatetuitionplus1yr: numberNull(get(data, 'costs.costItems.field_he_instatetuitionplus1yr.value', null)),
          field_he_outofstateflatfee: numberNull(get(data, 'costs.costItems.field_he_outofstateflatfee.value', null)),
          field_he_outofstateflatfeeplus1y: numberNull(get(data, 'costs.costItems.field_he_outofstateflatfeeplus1y.value', null)),
          field_he_outofstatetuition: numberNull(get(data, 'costs.costItems.field_he_outofstatetuition.value', null)),
          field_he_outofstatetuitionplus1y: numberNull(get(data, 'costs.costItems.field_he_outofstatetuitionplus1y.value', null)),
          field_he_percredithourchargeamnt: numberNull(get(data, 'costs.costItems.field_he_percredithourchargeamnt.value', null)),
          field_he_percredithourfeeplus1yr: numberNull(get(data, 'costs.costItems.field_he_percredithourfeeplus1yr.value', null)),
          field_he_typicalboardcharge: numberNull(get(data, 'costs.costItems.field_he_typicalboardcharge.value', null)),
          field_he_typicalboardchargeplus1: numberNull(get(data, 'costs.costItems.field_he_typicalboardchargeplus1.value', null)),
          field_he_typicalroomandboardchar: numberNull(get(data, 'costs.costItems.field_he_typicalroomandboardchar.value', null)),
          field_he_typicalroomboardcharge1: numberNull(get(data, 'costs.costItems.field_he_typicalroomboardcharge1.value', null)),
          field_he_typicalroomcharge: numberNull(get(data, 'costs.costItems.field_he_typicalroomcharge.value', null)),
          field_he_typicalroomchargeplus1y: numberNull(get(data, 'costs.costItems.field_he_typicalroomchargeplus1y.value', null)),
        },
        field_he_feeyear: get(data, 'costs.costItems.field_he_feeyear.value', null),
      },
    },
    general: {
      field_he_act_code: numberNull(get(data, 'overview.field_he_act_code.value', null)),
      field_he_avg_class_size: numberNull(get(data, 'overview.field_he_avg_class_size.value', null)),
      field_he_city_size: get(data, `overview.campusSurroundings.citySizeOptions[${get(data, 'overview.campusSurroundings.citySize.value', null)}]`, ''),
      field_he_control_id: get(data, `overview.schoolType.control.options[${get(data, 'overview.schoolType.control.value', null)}]`, ''),
      field_he_institution_id: numberNull(get(data, 'overview.field_he_institution_id.value', null)),
      field_he_level: get(data, `overview.schoolType.level.options[${get(data, 'overview.schoolType.level.value', null)}]`, ''),
      field_he_lgbt_rating: get(collegeService, 'esData.fullProfile.general.field_he_lgbt_rating', null),
      field_he_location: {
        lat: numberNull(get(data, 'overview.field_he_location.lat.value', null)),
        lon: numberNull(get(data, 'overview.field_he_location.lon.value', null)),
      },
      field_he_missionstatement: get(data, 'overview.openingStatement.value', null),
      field_he_name: collegeName,
      field_he_navianceid: get(data, 'overview.field_he_navianceid.value', null),
      field_he_nearestcity: get(data, 'studentLife.nearestCity.city.value', null),
      field_he_nearestmajorcitymiles: numberNull(get(data, 'studentLife.nearestCity.distance.value', null)),
      field_he_programsonline_id: get(data, `overview.field_he_programsonline_id.options[${get(data, 'overview.field_he_programsonline_id.value', null)}]`, ''),
      field_he_religious_affiliation: get(data, 'overview.field_he_religious_affiliation', null),
      field_hiid: get(collegeService, 'esData.fullProfile.general.field_hiid', ''),
    },
    student_organization: {
      field_he_studentorg_id_ref: {
        field_he_orgrepresented: Object.values(get(data, 'studentLife.organizations', {})).filter((org) => org.value === '1'),
        field_he_numsocialsor: numberNull(get(data, 'studentLife.greekLife.sororities.value', null)),
        field_he_numsocialfrat: numberNull(get(data, 'studentLife.greekLife.fraternities.value', null)),
      },
    },
    computing_environment: {
      field_he_comenvironment_ref: {
        field_he_purchaseplanoffered: trueFalse(get(data, 'studentLife.computingResources.computerPurchaseOffered.value', null), true),
        field_he_prefered_computer_type: collegeService.cmsDataMapping.field_he_prefered_computer_type_values[get(data, 'studentLife.computingResources.preferredComputerType.value', 0)],
        field_he_pcsinstudentcenters: get(data, 'studentLife.computingResources.numberOfPCsInStudentCenters.value', null),
        field_he_pcsinresidences: get(data, 'studentLife.computingResources.numberOfPCsInResidences.value', null),
        field_he_pcsinother: get(data, 'studentLife.computingResources.numberOfPCsInOther.value', null),
        field_he_pcsinlibrary: get(data, 'studentLife.computingResources.numberOfPCsInLibraries.value', null),
        field_he_pcsindepartmentlabs: get(data, 'studentLife.computingResources.numberOfPCsInDepartmentLabs.value', null),
        field_he_pcsincomputercenters: get(data, 'studentLife.computingResources.numberOfPCsInComputerCenters.value', null),
        field_he_macsinstudentcenters: get(data, 'studentLife.computingResources.numberOfMacsInStudentCenters.value', null),
        field_he_macsinresidences: get(data, 'studentLife.computingResources.numberOfMacsInResidences.value', null),
        field_he_macsinother: get(data, 'studentLife.computingResources.numberOfMacsInOther.value', null),
        field_he_macsinlibrary: get(data, 'studentLife.computingResources.numberOfMacsInLibraries.value', null),
        field_he_macsindepartmentlabs: get(data, 'studentLife.computingResources.numberOfMacsInDepartmentLabs.value', null),
        field_he_macsincomputercen: get(data, 'studentLife.computingResources.numberOfMacsInComputerCenters.value', null),
        field_he_internetwireless: trueFalse(get(data, 'studentLife.computingResources.wirelessInternetAccess.value', null), true),
        field_he_internetinresidencehall: trueFalse(get(data, 'studentLife.computingResources.internetAccessInResidenceHalls.value', null), true),
        field_he_internetinlibrary: trueFalse(get(data, 'studentLife.computingResources.internetAccessInLibrary.value', null), true),
        field_he_internetincentralloc: trueFalse(get(data, 'studentLife.computingResources.internetAccessOnCentralCampus.value', null), true),
        field_he_computerrequiredreason: get(data, 'studentLife.computingResources.computerRequiredReason.value', ''),
        field_he_computerrequired: trueFalse(get(data, 'studentLife.computingResources.computerRequired.value', null), true),
      },
    },
    field_address_id: {},
    special_service: {
      field_he_specialserviceid_ref: {
        he_special_services_id_ref: {
          field_he_special_services_id_ref: [
            ...Object.values(get(data, 'studentLife.services', {})).filter((org) => org.targetId && org.value === '1'),
            ...Object.values(get(data, 'studies.studyOptions', {})).filter((org) => org.value === '1'),
          ],
        },
        he_special_service_us: {
          field_he_teachercertpgms: trueFalse(get(data, 'studies.studyOptions.teacherCertificationPrograms.value', null), true),
          field_he_weekendcollege: trueFalse(get(data, 'studies.studyOptions.weekendCollege.value', null), true),
          field_he_honorsprogram: trueFalse(get(data, 'studies.studyOptions.honorsProgram.value', null), true),
          field_he_combineddegreepgms: trueFalse(get(data, 'studies.studyOptions.cooperativeEducationPrograms.value', null), true),
          field_he_acceleratedprogram: trueFalse(get(data, 'studies.studyOptions.acceleratedProgram.value', null), true),
          field_he_domstudyawaypgms: trueFalse(get(data, 'studies.studyOptions.domesticStudyAwayPrograms.value', null), true),
          field_he_internships: trueFalse(get(data, 'studies.studyOptions.internships.value', null), true),
          field_he_weekendeveningpgms: trueFalse(get(data, 'studies.studyOptions.weekendEveningPrograms.value', null), true),
          field_he_rotcnavy: trueFalse(get(data, 'studentLife.services.ROTCNavy.value', null), true),
          field_he_independentstudy: trueFalse(get(data, 'studies.studyOptions.independentStudy.value', null), true),
          field_he_doublemajor: trueFalse(get(data, 'studies.studyOptions.doubleMajor.value', null), true),
          field_he_rotcarmy: trueFalse(get(data, 'studentLife.services.ROTCArmy.value', null), true),
          field_he_cooperativeedupgms: trueFalse(get(data, 'studies.studyOptions.cooperativeEducationPrograms.value', null), true),
          field_he_rotcair: trueFalse(get(data, 'studentLife.services.ROTCAirforce.value', null), true),
          field_he_rotcservperoppcollege: trueFalse(get(data, 'studentLife.services.ROTCServicepersonOpportunityCollege.value', null), true),
          field_he_externaldegreeprogram: trueFalse(get(data, 'studies.studyOptions.externalDegreeProgram.value', null), true),
        },
        field_he_ld_programs: get(data, `studentLife.field_he_ld_programs.options[${get(data, 'studentLife.field_he_ld_programs.value', null)}]`, ''),
        field_he_counseling_services: trueFalse(get(data, 'studentLife.services.field_he_counseling_services.value', null)),
        calc_he_tutoringservices: Object.values(get(data, 'studentLife.services', {}))
          .map((item) => ({ name: item.name, value: item.value }))
          .filter((item) => (item.value === '1' && item.name && (item.name === 'Peer Tutors' || item.name === 'Professional Tutors')))
          .length > 0,
        calc_he_studyabroad: Object.values(get(data, 'studies.studyOptions', {}))
          .map((item) => ({ name: item.name, value: item.value }))
          .filter((item) => (item.value === '1' && item.name && item.name.substr(0, 12) === 'Study Abroad'))
          .length > 0,
        calc_he_learning_differences_support: [1, 2].includes(numberNull(get(data, 'studentLife.field_he_ld_programs.value', null))),
      },
    },
  };

  return esLikeData;
};

export default basicInfoToHubsMapper;
